/**
 * Two buttons toggle the search form:
 *
 * 1. .menu-main .menu-item-search (when form is hidden)
 * 2. .menu-main--searchform__button
 */

const menuMain = document.querySelector(".menu-main");
const menuIcon = document.querySelector(".menu-main .menu-item-search");
const searchForm = document.querySelector(".menu-main form.searchform");
const formInput = searchForm.querySelector("input");
const formIcon = searchForm.querySelector(
  ".menu-main .menu-main--searchform__searchbutton",
);

const cancelClickHandler = (e) => {
  if (e.target.closest(".menu-main form.searchform")) return;
  showForm(false);
};

const escKeyHandler = (e) => {
  console.log({
    key: e.key,
    ctrl: e.ctrlKey,
    alt: e.altKey,
    shift: e.shiftKey,
  });
  if (e.key == "Escape" && !(e.ctrlKey || e.altKey || e.shiftKey)) {
    if (formInput.value.length) {
      formInput.value = "";
    } else {
      showForm(false);
    }
  }
};

const showForm = (onOff) => {
  if (onOff) {
    console.log("search: active (add class)");
    menuMain.classList.add("searchform-active");
    document.addEventListener("keydown", escKeyHandler);
    setTimeout(
      () => document.addEventListener("click", cancelClickHandler),
      100,
    );
  } else {
    console.log("search: inactive (remove class)");
    menuMain.classList.remove("searchform-active");
    document.removeEventListener("keydown", escKeyHandler);
    document.removeEventListener("click", cancelClickHandler);
  }
};

const clickHandler = (e) => {
  e.preventDefault();

  if (e.currentTarget.className.includes("menu-item-search")) {
    showForm(true);

    setTimeout(() => formInput.focus(), 200);
  } else {
    console.log({ val: formInput.value, len: formInput.value.length });
    if (formInput.value.length) {
      console.log("sending search");
      searchForm.submit();
      return;
    } else {
      showForm(false);
    }

    // searchForm.classList.remove("visible");
  }
};

menuIcon.addEventListener("click", clickHandler);
formIcon.addEventListener("click", clickHandler);

// searchForm.classList.add("visible");

// let flipper = 0;
// window.looper = setInterval(() => {
//   if (flipper % 2 == 0) {
//     menuMain.classList.add("searchform-active");
//   } else {
//     menuMain.classList.remove("searchform-active");
//   }
//   flipper++
// }, 2000);
